import { useState, useEffect } from "react";
// node.js library that concatenates classes (strings)


// reactstrap components
import {
	Card,
	CardHeader,
	Table,
	Container,
	CardBody,
	Row,
	Col,
	Modal,
	Button
} from "reactstrap";
import GoogleMapReact from 'google-map-react';
import Header from "../../components/Headers/Header.js";

import helper from '../../services/helper.service';
import adminApi from '../../services/admin.service';
import customerService from "../../services/customer.service.js";
import { calculateGameProperties, getLocalDate, sortGames, statusText, getTransportDisplay } from "../../utils/games.js";
import { strTo12Hours, strTo24Hours } from "../../utils/date.js";
import CustomMarker from "../../components/Markers/CustomMarker.js";
import MapLegend from "../../components/MapLegend";
let interval = null;
function  AdminSummary(props){
	const [games, setGames] = useState([]);
	const [clubs, setClubs] = useState([]);
	const [showMap, setShowMap] = useState(false);
	const [sortConfig, setSortConfig] = useState({ key: 'id', direction: "asc" });
	const [GPSTrackers, setGPSTrackers] = useState([]);
	const [sortedGames, setSortedGames] = useState([]);

	useEffect(() => {
		getClubList();
		fetchGPSTrackers();
	}, []);

	useEffect(() => {
		if(clubs.length) {
			populateGames();
			interval && clearInterval(interval);
			interval = setInterval(() => {
				populateGames();
			}, 20000);
			return () => {
				interval && clearInterval(interval);
			}
		}
	}, [clubs]);

	useEffect(() => {
		setSortedGames(sortGames(games, sortConfig));
	}, [games, sortConfig]);

	const fetchGPSTrackers = () => {
		adminApi.getGPSTrackers().then((response) => {
			if (response.status === 200) {
				setGPSTrackers(response.data);
			} else {
				helper.showToast("Error", "Failed to fetch GPS Trackers.", 3);
			}
		});
	};
	const getClubList = async () => {
		const response = await adminApi.getClubList({});
		try {
			if(response.status === 200){
				const clubData = response.data;
				const promisesOfClubs = clubData.map(async (club) => {
					if(club.has_27_holes === "false") {
						const payload = { club_id: club.id };
						const boxTimesResponse = await customerService.getBoxTimeList(payload);
						if (boxTimesResponse.status === 200) {
							club.boxTimes = boxTimesResponse.data;
						}
						return club;
					}
					return null;
				})
				const clubsWithBoxTimes = await Promise.all(promisesOfClubs);
				setClubs(clubsWithBoxTimes);
			} else {
			
					helper.showToast('Error', 'Failed to get.', 3);
			}

		}catch(error) {
			console.log("err: ", error);
		
			helper.showToast('Error', 'Invalid auth', 3);
		}
	}
	const populateGames = async () => {
		if(clubs.length) {
			const gamesPromises = clubs.map(async (club) => {
				if(club?.has_27_holes === "false") {
					const date = getLocalDate();
					const payload = { club_id: club.id, date: date};
					const gamesResponse = await customerService.getGames(payload);
					if (gamesResponse.status === 200) {
						const tempGames = calculateGameProperties(club.boxTimes, gamesResponse.data, date);
						tempGames.forEach((game) => {
							game.club_name = club.name;
							game.map_marker_label = club.map_marker_label;
						});
						return tempGames;
					}
				}
				return [];
			});
			const gamesLists = await Promise.all(gamesPromises);
			setGames(gamesLists.flat());
		}
	}

	const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "↕";
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

	const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

	return (
		<div>
			<Header count = {games.length} lable={"Active Games"}/>
			<Container className="mt--7" fluid >
			<Modal isOpen={showMap} toggle={() => setShowMap(false)} modalClassName="map-modal">
					<div style={{ height: '95vh', width: '100%', position: 'relative'  }}>
						<GoogleMapReact
								bootstrapURLKeys={{ key: 'AIzaSyCk2rpWi4waVXWK-zBmstyi7JJOlHinwI8' }}
								yesIWantToUseGoogleMapApiInternals
								defaultCenter={{ lat: 39.8283, lng: -98.5795 }}
								defaultZoom={4}
								options={(maps) => ({
									mapTypeId: maps.MapTypeId.SATELLITE,
									rotateControl: true,
								})}
						>
							{
								games.filter(game => game.last_lat_long).map((game, index) => 
									<CustomMarker
										key={index}
										lat={game.last_lat_long[0]}
										lng={game.last_lat_long[1]}
										game={{
												...game,
												actual_time: game.actual_time_org ? strTo24Hours(game.actual_time_org) : game.tee_time,
												caddie_name: (
														GPSTrackers.find(device => device.tracking_id === game.tracker_id)
													)?.caddie_name || game.tracker_type,
												tracker_number: (() => {
													const t = GPSTrackers.find(device => device.tracking_id === game.tracker_id);
													if (!t || !t.name) return null;
													const part = (t.name.split('-')[0] || '').trim();
													return part || null;
												})()
											}}
										label={game.map_marker_label || "start_time"}
									/>
								)
							}
						</GoogleMapReact>
<Button
							color="danger"
							style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}
							onClick={() => setShowMap(false)}
						>
							Close Map
						</Button>
						<MapLegend />
					</div>
				</Modal>
			<Row>
				<Col xl="12">
					<Card className="shadow">
						<CardHeader className="bg-white border-0 d-flex flex-wrap justify-content-between align-items-center">
							<h3 className="mb-0">Games
							</h3>
							
							<div className="d-flex flex-wrap">
								<Button color="primary" onClick={() => setShowMap(true)} className="mr-2 mb-2">
									View Map
								</Button>
							</div>
						</CardHeader>
			
						<CardBody style={{ padding: '0.5rem' }}>
							<div style={{ width: '100%', overflowX: 'auto' }}>
								<Table responsive hover size="sm" className="mb-0">
									<thead className="thead-light" style={{ position: 'sticky', top: 0, background: '#f8f9fe', zIndex: 2 }}>
										<tr>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('id')}>{'ID'} 
												<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('id')}</span>
											</th>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('club_name')}>Club Name 
												<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('club_name')}</span>
											</th>
											<th className="py-2 px-2">Type</th>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('tee_time')}>
												<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
													<div>Tee<br />Time </div>
													<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('tee_time')}</span>
												</div>
											</th>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('actual_time')}>
												<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
													<div>Start<br />Time</div>
													<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('actual_time')}</span>
												</div>
											</th>
											<th className="py-2 px-2">
												Start<br />Hole
											</th>
											<th className="py-2 px-2">
												Last<br />Hole
											</th>
											<th className="py-2 px-2">
												Holes<br />Played
											</th>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('time_through_last_hole_org')}>
												<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
													Last<br />Time
													<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('time_through_last_hole_org')}</span>
												</div>
											</th>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('pace')} >
												Pace
												<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('pace')}</span>
											</th>
											<th className="py-2 px-2">Tracker</th>
											<th className="py-2 px-2 cursor-pointer" onClick={() => handleSort('transport_mode')}>
												Transport
												<span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('transport_mode')}</span>
											</th>
											<th className="py-2 px-2">Status</th>
										</tr>
									</thead>

									<tbody>
										{sortedGames.map((game, index) => (
											<tr key={game.id} style={{ fontSize: '0.85rem' }} >
												<td className="py-1 px-2">{game.id}</td>
												<td className="py-1 px-2">{game.club_name}</td>
												<td className="py-1 px-2">{game.display_type}</td>
												<td className="py-1 px-2">{game.tee_time && strTo12Hours(game.tee_time)} {game.auto_game === 1 && '*'}</td>
												<td className="py-1 px-2">{game.actual_time}</td>
												<td className="py-1 px-2">{game.start_hole}</td>
												<td className="py-1 px-2">{game.last_hole_played}</td>
												<td className="py-1 px-2">{game.total_holes_played}</td>
												<td className="py-1 px-2">{game.time_through_last_hole}</td>
												<td className="py-1 px-2" style={{ color: game.pace_formatted[0] === '(' ? 'red' : 'green' }}>
													{game.pace_formatted}
												</td>
												<td className="py-1 px-2">
													{game.tracker_type} - {(
														GPSTrackers.find(device => device.tracking_id === game.tracker_id)
													)?.name}
												</td>
												<td className="py-1 px-2">{getTransportDisplay(game)}</td>
												<td className="py-1 px-2">{statusText[game.status]}</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
			</Container>
		</div>
	);
};

export default AdminSummary;